import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { FormulaEffects } from './formula.effects';
import { reducer } from './formula.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forFeature('formula', reducer),
    EffectsModule.forFeature([FormulaEffects]),
  ],
  providers: [FormulaEffects],
})
export class FormulaStoreModule {}
